// src/lib/layouts/resolveFields.ts
import type { FieldDescriptor, PostLayoutConfig } from './types';
import type { PostLayoutDef } from './registry';

/** Resolve a def's fields, which may be static or config-dependent (e.g. news_post per style). */
export function resolveFields(
  def: Pick<PostLayoutDef<PostLayoutConfig>, 'fields'> | undefined,
  config: PostLayoutConfig,
): FieldDescriptor[] {
  if (!def) return [];
  return typeof def.fields === 'function' ? def.fields(config) : def.fields;
}
